import { render, staticRenderFns } from "./ConfigScheduleViewNearMatchNotificationsDetails.vue?vue&type=template&id=2eb67100&scoped=true&"
import script from "./ConfigScheduleViewNearMatchNotificationsDetails.vue?vue&type=script&lang=js&"
export * from "./ConfigScheduleViewNearMatchNotificationsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConfigScheduleViewNearMatchNotificationsDetails.vue?vue&type=style&index=0&id=2eb67100&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb67100",
  null
  
)

export default component.exports